import { APP_NAME, $document } from '../utils/environment';
import AbstractModule from './AbstractModule';
import ScrollManager from '../scroll/vendors/ScrollManager';

const MODULE_NAME = 'Contact';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const Event = {
    SUBMIT: `submit.${EVENT_NAMESPACE}`
};

const Selector = {
    FORM         : '.js-form',
};

export default class extends AbstractModule {
    constructor(options) {
        super(options);
        this.captchaId = null;
    }

    init() {
        this.$captcha = $('.js-captcha', this.$el);
        this.$el.on(Event.SUBMIT, Selector.FORM, (event) => this.onSubmit(event));

        this.$el.find('.js-file').on('change', (e) => {
            const val = e.currentTarget.files[0].name;
            $(e.currentTarget).siblings('.js-file-label').text(val);
        });
    }

    onSubmit(e) {
        e.preventDefault();

        if (this.captchaId === null && this.$captcha.length > 0) {
            const id = this.$captcha.html('').get(0).getAttribute('id');
            this.captchaId = window.grecaptcha.render(id, {
                sitekey : window.recaptchaKey,
                size    : 'invisible',
                callback: (token) => {
                    $('.js-captcha-response', this.$form).val(token);
                    this.$el.addClass('has-loaded-captcha');
                    this.sendData(e);
                }
            });
            window.grecaptcha.execute(this.captchaId);
        } else {
            this.sendData(e);
        }
        return false;
    }

    sendData(event) {
            let $form = $(event.currentTarget);
            let $submitButton = $form.find('.js-form-submit');
            let $requiredInputs = $form.find('.js-required');

            // $form.prop('disabled', true);
            $submitButton.attr('disabled', true).prop('disabled', true);

            let errorMessage   = "Une erreur s'est produite";
            let invalidMessage = "Invalide";
            let successMessage = "Votre demande est envoyée!";
            let abort = false;

            // Required input.
            $requiredInputs.each(function (i,e) {
                let $this = $(this);
                let $inputWrap = $this.parents('.js-input-wrap');

                if (!$this.val()) {
                    $inputWrap.addClass('has-error');
                    abort = true;

                    $('.js-overlay').animate({
                        scrollTop: 0
                    }, 300);
                } else {
                    $inputWrap.removeClass('has-error');
                }
            });

            if (abort) {
                return false;
            }

            const formData = new FormData($form.get(0));

            $.ajax({
                method:   $form.attr('method'),
                url:      $form.attr('action'),
                data:     formData,
                contentType: false,
                processData: false
            })
            .then((response, textStatus, jqXHR) => {

                if (!response || !response.success) {
                    return $.Deferred().reject(jqXHR, textStatus, errorMessage);
                }

                return $.Deferred().resolve(response, textStatus, jqXHR);
            })
            .done((response, textStatus, jqXHR) => {
                // Wow bravo!
                let $parent = $form.parent();

                // $form.remove();
                $('.js-form-hide').remove();

                $document.triggerHandler({
                    type: 'rebuild.LocomotiveScroll'
                })

                let message = response.message || successMessage;

                $parent.html('<section class="o-section -padding -min-height"><div class="o-container"><p class="o-h2">' + message + '</p></div></section>');

                $document.triggerHandler({
                    type: 'scrollTo.LocomotiveScroll',
                    options: {
                        targetElem: $parent,
                        speed: 600
                    }

                })

            })
            .fail((jqXHR, textStatus, errorThrown) => {
                const response = jqXHR.responseJSON;

                // an error occured
                if(!response.errors.length) {}

                let fileError = "";
                response.errors.map((error, index) => {
                    if(error.property === 'file-size' || error.property === 'file-type') {
                        fileError += `${error.message} `;
                    }
                });
                $('.o-input_error.file').html(fileError);
            });
    }

    destroy() {
        super.destroy();
    }
}

